import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const rolesQuery = createApi({
  baseQuery,
  reducerPath: "rolesQueries",
  endpoints: (builder) => ({
    createRole: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.role.create)}`,
        method: "POST",
        body: data,
      }),
    }),
    updateRole: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.role.update)}`,
        method: "PUT",
        body: data,
      }),
    }),
    getAllRoles: builder.mutation<any, any>({
      query: ({
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        is_audit = false,
        data,
      }) => ({
        url: `${formatString(
          endPoints.role.getAll
        )}?from=${from}&size=${size}&is_audit=${is_audit}${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }`,
        method: "POST",
        body: data,
      }),
    }),
    deleteRole: builder.mutation<any, any>({
      query: ({ code }) => ({
        url: `${formatString(endPoints.role.delete, {
          key: urlKeys.code,
          value: code,
        })}`,
        method: "DELETE",
      }),
    }),
    selectRole: builder.mutation<any, any>({
      query: ({ code, module, is_audit = false }) => ({
        url: `${formatString(endPoints.role.select, {
          key: urlKeys.code,
          value: code,
        })}?${
          module && `module=${encodeURIComponent(module)}`
        }&is_audit=${is_audit}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useGetAllRolesMutation,
  useDeleteRoleMutation,
  useSelectRoleMutation,
} = rolesQuery;
